export enum DocumentationFiltersTypesMap {
  recordTypes = 'recordTypes',
  steps = 'steps',
  fieldTypes = 'fieldTypes',
  automationTypes = 'automationTypes',
  apexTypes = 'apexTypes',
  utilization = 'utilization',
  activeState = 'activeState',
  configurationType = 'configurationType',
  relatedObject = 'relatedObject',
  objectTypes = 'objectTypes',
  namespace = 'namespace',
  actionTypes = 'actionTypes',
  operations = 'operations',
  status = 'status',
}
export interface DocumentationValuedFilters {
  selectedValues: string[];
}
